import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-generateReport',
    template: `
  <button title="Generate Validation Summary Report" (click)="generateReport($event);" class="btn btn-outline btn-success btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
  <i class="fas fa-play-circle"></i>
  </button>`,
    standalone: false
})
export class GenerateReport implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  generateReport($event) {
    console.log("hello")
    if (this.params.generateReport instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.generateReport(params);

    }
  }
}
